import React, {useEffect, useState} from 'react';
import BreadPath from "../../Components/BreadPath/BreadPath";
import MyCart from "../../Components/MyCart/MyCart";
import {Button, Container, Paper, Step, StepContent, StepLabel, Stepper, Typography} from "@mui/material";
import SizeTest from "../../Components/SizeTest/SizeTest";
import Box from "@mui/material/Box";
import Boxberry from "../../Components/Boxberry/Boxberry";
import Contacts from "../../Components/Contacts/Contacts";
import PayMethod from "../../Components/PayMethod/PayMethod";
import OrderDeltails from "../../Components/OrderDeltails/OrderDeltails";
import {toast, ToastContainer} from "react-toastify";
import BackServer from "../../api/BackServer";
import {useNavigate} from "react-router-dom";
const BreadCart=[{key:"Главная", link:"/"}, {key:"Каталог", link:"/catalog"},{key:"Корзина", link:"/cart"} ]



const FullCart = (props) => {
    const [activeStep, setActiveStep] = React.useState(0);
    const [delivery, setDelivery]= React.useState("")
    const [bx_ordersum, setBx_Ordersum]= React.useState(1001); //Объявленная стоимость посылки
    const [bx_weight, setBx_weight]= React.useState(100); //Вес посылки в граммах, обязательно должен быть >0
    const [bx_paysum, setBx_paysum]= React.useState(0); //Сумма к оплате покупателем (оплата при получении)
    const [bx_height, setBx_height]= React.useState(50); //Высота коробки
    const [bx_width, setBx_width]= React.useState(50); //Ширина коробки
    const [bx_depth, setBx_depth]= React.useState(50); //Глубина коробки
    const [bx_api, setBx_api]= React.useState("1$69a1204f297914a82fad04bda2566d34"); //Глубина коробки
    const [products, setProducts] = useState([])
    const [sum, setSum] = useState([])
    const [summWeight, setSummWeight]=useState(0)
    var favor= JSON.parse( localStorage.getItem('cart'))
    var deliveryx=JSON.parse(localStorage.getItem('delivery'))
    var payMethod=JSON.parse(localStorage.getItem('payMethod'))
    var contacts= JSON.parse(localStorage.getItem('contacts'))
    const order = async (result) => {
        const  response = await BackServer.CreateNewOrder(result)
        console.log(response)
    }
    let navigate = useNavigate();
    function CreateOrder(){
        favor= JSON.parse( localStorage.getItem('cart'))
        deliveryx=JSON.parse(localStorage.getItem('delivery'))
        payMethod=JSON.parse(localStorage.getItem('payMethod'))
        contacts= JSON.parse(localStorage.getItem('contacts'))
        var result= {
                id:"",
                products:products,
                delivery:deliveryx,
                payMethod:payMethod,
                contacts:contacts
            }
        toast.warning("Создаём заказ. Не закрывайте вкладку!", {
            position: "top-center", autoClose: 8000, hideProgressBar: false,
            closeOnClick: false, pauseOnHover: false, draggable: false,
            progress: undefined, theme: "colored",
        });
        createNewOrder(result)
        // order(result).then()
        // console.log(xxx)
    }

    const createNewOrder = async (result) => {
        const response = await BackServer.CreateNewOrder(result).then(u => {
            if (u) {
                console.log(u)

                var colcart=[]
                localStorage.setItem('cart',JSON.stringify(colcart));
                var deliverynew= {
                    Type:"Самовывоз",
                    BoxBerryPVZ:{adress:"не выбран",price:"0"},
                    BoxBerryPVZText:"",
                    Adress:"г.Москва, ул.Богородский вал 6к2, (м.Преображенская площадь)",
                    ViewText:"",
                    Zip:"",
                    Price:0,
                    Phone:"+7(916)386-50-50"
                }
                localStorage.setItem('delivery',JSON.stringify(deliverynew));
                navigate("/catalog");
            }
        }).catch(function (error) {
            if (error.response) {
                if (error.response.data.message.statusCode == 500) {
                    toast.error("Ошибка в данных: "+ error.response.data.message.status, {
                        position: "top-center", autoClose: 5000, hideProgressBar: false,
                        closeOnClick: true, pauseOnHover: true, draggable: true,
                        progress: undefined, theme: "colored",
                    });
                }
            } else {
                toast.error('Произошла ошибка', {
                    position: "top-center", autoClose: 5000, hideProgressBar: false,
                    closeOnClick: true, pauseOnHover: true, draggable: true,
                    progress: undefined, theme: "colored",
                });
            }
            console.log(error.config);
        });

    }




    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };



    const getProducts = async () => {

        await BackServer.GetCart(favor).then(u => {
            if (u) {
                // console.log(u.message.Products)
                setSum(u.message.Products.category.Cost)
                setProducts(u.message.Products.lst)
                setSummWeight(u.message.Products.category.Weight)
            }
        })}

    useEffect(() => {
        getProducts()
    }, [])
    var steps = [
        {
            label: 'Состав заказа',
            description:  <MyCart callNext={handleNext}  callBackX={handleBack} callbackX={props.callbackX}/>,
            buttonName: "Перейти к доставке",
            caption:<Typography variant="caption">Выбор товаров, уточнение размеров и количества</Typography>
        },
        {
            label: 'Доставка',
            description:   <Boxberry callNext={handleNext}  callBackX={handleBack}  ordersum={sum} weight={summWeight} paysum={bx_paysum} height={bx_height}  width={bx_width}  depth={bx_depth}  api={bx_api}  ></Boxberry>,
            buttonName: "Перейти способам оплаты",
            caption:<Typography variant="caption">Выбор способа доставки заказа</Typography>
        },
        {
            label: 'Оплата',
            description:<PayMethod callNext={handleNext}  callBackX={handleBack}></PayMethod>,
            buttonName: "Перейти к контактным данным",
            caption: <Typography variant="caption">Выбор способа оплаты заказа</Typography>
        },
        {
            label: 'Получаталь',
            description:<Contacts callNext={handleNext}  callBackX={handleBack} ></Contacts>,
            buttonName: "Проверить и оформить заказ",
            caption:<Typography variant="caption">Указание контактных данных получателя заказа</Typography>
        },
        {
            label: 'Проверка данных заказа',
            description:<OrderDeltails callNext={CreateOrder} callBackX={handleBack} callreset={handleReset}/>,
            buttonName: "Всё верно",
            caption: <Typography variant="caption">Проверка всех данных по заказу</Typography>
        },


    ];

    return (

        <Container  maxWidth="xl">
            {/*<ToastContainer />*/}
            <BreadPath key={"ddd"}  path={BreadCart}/>
            {/*<SizeTest/>*/}

            <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((step, index) => (
                    <Step key={step.label}>
                        <StepLabel
                            optional={step.caption}
                        >
                            {step.label}
                        </StepLabel>
                        <StepContent>
                            <Typography>{step.description}</Typography>
                            {/*<Box sx={{ mb: 2 }}>*/}
                            {/*    <div>*/}
                            {/*        <Button*/}
                            {/*            variant="contained"*/}
                            {/*            onClick={handleNext}*/}
                            {/*            sx={{ mt: 1, mr: 1 }}*/}
                            {/*        >*/}
                            {/*            {step.buttonName}*/}
                            {/*        </Button>*/}
                            {/*        <Button*/}
                            {/*            variant="contained"*/}
                            {/*            disabled={index === 0}*/}
                            {/*            onClick={handleBack}*/}
                            {/*            sx={{ mt: 1, mr: 1 }}*/}
                            {/*        >*/}
                            {/*            Назад*/}
                            {/*        </Button>*/}
                            {/*    </div>*/}
                            {/*</Box>*/}
                        </StepContent>
                    </Step>
                ))}
            </Stepper>
            {activeStep === steps.length && (
                <Paper square elevation={0} sx={{ p: 3 }}>
                    <Typography>All steps completed - you&apos;re finished</Typography>

                    <Button onClick={CreateOrder} sx={{ mt: 1, mr: 1 }}>
                        Оформить заказ
                    </Button>
                    <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
                        Reset
                    </Button>
                </Paper>
            )}
        </Container>
    );
};

export default FullCart;